module.exports = __webpack_public_path__ + "static/media/add-to-cart.a12dcc66.svg";